<template>

    <v-dialog>
        <v-btn flat small slot="activator"><v-icon small left>mail_outline</v-icon><span class="text-lowercase">E-mail</span></v-btn>
        <v-card>
            <form ref="sup">
            <v-card-title>
                <h5 class="text-uppercase text-xs-right">Enviar Mensagem</h5>
            </v-card-title>
            <v-card-text>
            <v-layout row>
                <v-flex xs12>
                    <v-text-field label="Nome" prepend-icon="person" :rules="inputRules" v-model="contato.nome"></v-text-field>
                </v-flex>
            </v-layout>
             <v-layout row>
                <v-flex xs12>
                    <v-text-field label="Email" prepend-icon="mail" :rules="inputRules" v-model="contato.email"></v-text-field>
                </v-flex>
            </v-layout>
             <v-layout row>
                <v-flex xs12>
                    <v-text-field label="Telefone" prepend-icon="phone" v-model="contato.telefone"></v-text-field>
                </v-flex>
            </v-layout>
             <v-layout row>
                <v-flex xs12>
                    <v-textarea label="Mensagem" prepend-icon="message" :rules="inputRules" v-model="contato.mensagem"></v-textarea>
                </v-flex>
            </v-layout>


            <v-layout row justify-center>
                <v-card flat>
                    <v-btn round outline small class="text-lowercase" color="#099AB1" @click="window.open('mailto:test@example.com')">enviar</v-btn>
                </v-card>
            </v-layout>

        </v-card-text>
            </form>
        </v-card>
    </v-dialog>
</template>

<script>


export default {
  data() {
    return {
      contato: {
        nome: '', email: '', telefone: '', mensagem: '',
      },
      inputRules: [v => v.length >= 1 || 'Campo requerido!'],
    };
  },


};
</script>

<style>

</style>
